import { useEffect, useState } from 'react'
import { useAuthStore } from '../stores/authStore'
import { labService } from '../services'

export default function Debug() {
  const { user, token, isAuthenticated } = useAuthStore()
  const [localStorageToken, setLocalStorageToken] = useState(null)
  const [authStorage, setAuthStorage] = useState(null)
  const [apiTest, setApiTest] = useState(null)

  useEffect(() => {
    // Check localStorage
    const storedToken = localStorage.getItem('auth-token')
    const storedAuth = localStorage.getItem('auth-storage')
    
    setLocalStorageToken(storedToken)
    setAuthStorage(storedAuth)

    // Test API call
    labService.getAll()
      .then(data => setApiTest({ success: true, data }))
      .catch(error => setApiTest({ 
        success: false, 
        error: error.response?.data || error.message 
      }))
  }, [])

  return (
    <div className="max-w-4xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-8">Debug Information</h1>
      
      <div className="space-y-6">
        {/* Zustand Store */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Zustand Auth Store</h2>
          <div className="space-y-2 font-mono text-sm">
            <div>
              <span className="font-semibold">isAuthenticated:</span> 
              <span className={isAuthenticated ? 'text-green-600' : 'text-red-600'}>
                {' ' + String(isAuthenticated)}
              </span>
            </div>
            <div>
              <span className="font-semibold">user:</span> 
              <pre className="mt-2 bg-gray-100 p-2 rounded overflow-auto">
                {JSON.stringify(user, null, 2)}
              </pre>
            </div>
            <div>
              <span className="font-semibold">token:</span> 
              <div className="mt-2 bg-gray-100 p-2 rounded break-all">
                {token || 'null'}
              </div>
            </div>
          </div>
        </div>

        {/* localStorage */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">localStorage</h2>
          <div className="space-y-2 font-mono text-sm">
            <div>
              <span className="font-semibold">auth-token:</span> 
              <div className="mt-2 bg-gray-100 p-2 rounded break-all">
                {localStorageToken || 'null'}
              </div>
            </div>
            <div>
              <span className="font-semibold">auth-storage:</span> 
              <pre className="mt-2 bg-gray-100 p-2 rounded overflow-auto">
                {authStorage || 'null'}
              </pre>
            </div>
          </div>
        </div>

        {/* API Test */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">API Test (Labs Endpoint)</h2>
          {apiTest === null ? (
            <p className="text-gray-500">Loading...</p>
          ) : apiTest.success ? (
            <div>
              <p className="text-green-600 font-semibold mb-2">✓ Success</p>
              <pre className="bg-gray-100 p-2 rounded overflow-auto text-xs">
                {JSON.stringify(apiTest.data, null, 2)}
              </pre>
            </div>
          ) : (
            <div>
              <p className="text-red-600 font-semibold mb-2">✗ Failed</p>
              <pre className="bg-gray-100 p-2 rounded overflow-auto text-xs">
                {JSON.stringify(apiTest.error, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
